
<section>
  <div class="container-fluid banner-img d-flex justify-content-center align-items-center">
    <img class="bottomLogo" src="assets/images/white-logo.svg" alt="">
    <div class="row py-5">
      <div class="col-lg-12 col-md-12 col-sm-12 wow bounceInUp">
        <!-- form card login -->
        <div class="card login-card">
          <div class="card-header login-header">
            <div class="font-semi-bold pb-2">Forgot Password</div>
            <p class="font-regular mb-0">Confirm your email and we’ll send the link<br> to your email id.</p>
          </div>
          <div class="card-body pt-0">
            <div *ngIf="showAlert">
              <div *ngIf="alertType === 'success'" class="alert alert-success d-flex align-items-center" role="alert">
                <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img">
                  <use xlink:href="#check-circle-fill" /></svg>
                <div>
                  {{alertMsg}}
                </div>
              </div>
              <div *ngIf="alertType === 'error'" class="alert alert-danger d-flex align-items-center" role="alert">
                <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="">
                  <use xlink:href="#exclamation-triangle-fill" /></svg>
                <div>
                  {{alertMsg}}
                </div>
              </div>
            </div>
            <form class="form" [formGroup]="forgotPasswordForm" autocomplete="off">
              <div class="form-group mb-4">
                <label class="font-medium py-2 mt-0" for="email">Email Address</label>
                <input type="email" noSpaces class="form-control font-medium input-field"
                  [ngClass]="{ 'is-invalid': submitted && f['email'].errors}" (keydown.space)="$event.preventDefault()"
                  formControlName="email" placeholder="Enter your email address" />
                <div *ngIf=" submitted && f['email'].errors" class="invalid-feedback">
                  <div *ngIf="submitted && f['email'].errors['required']"> {{validationErrorMessage.email}} </div>
                </div>
                <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                  <div *ngIf="submitted && (f['email'].errors['email'] || f['email'].errors['pattern'] )">
                    {{validationErrorMessage.validEmail}}</div>
                </div>
              </div>
              <div class="form-group mt-3">
                <button type="submit" class="form-control submit-btn theme-button" id="btnLogin"
                  (click)="submit(forgotPasswordForm.value)">
                  <span>Submit</span>
                </button>
                <button type="submit" class="form-control mt-3 theme-button-dark" id="btnLogin" routerLink="/login">
                  <span>Cancel</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>